import React, { Component } from 'react';
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import LeftBar from '../Site/LeftBar';
import ProductContent from './ProductContent';

import './style.css';

class ProductDetail extends Component { 
  
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  }


  constructor(props) {
    super(props);
    
    const { location } = this.props
    console.log('path: '+ location.pathname )

    var pathArray = location.pathname.split('/');

    //pathArray[1] = product
    //pathArray[2] = client id
    //pathArray[3] = product id
    
    console.log('arr: '+ pathArray)
    
    this.state = {        
        productId : pathArray[2]
    };
  }

  render() {      
    
    return (
      <div>       
        <LeftBar />
        <ProductContent productId={this.state.productId} />
      </div>    


    );
  }
}

export default withRouter(ProductDetail);